ALLGEMEINE GESCHÄFTSBEDINGUNGEN (B2B)

1. Geltungsbereich

1.1 Diese Allgemeinen Geschäftsbedingungen (AGB) gelten ausschließlich für Unternehmer im Sinne des § 14 BGB.

1.2 Verbraucher im Sinne des § 13 BGB sind von der Nutzung der Anwendung ausgeschlossen.

1.3 Abweichende oder ergänzende Geschäftsbedingungen des Nutzers finden keine Anwendung, es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.

2. Vertragsgegenstand

2.1 Der Anbieter stellt eine webbasierte Software-Anwendung (Software-as-a-Service) zur Verfügung.

2.2 Die Anwendung dient der technischen Unterstützung bei Analyse-, Strukturierungs-, Verarbeitungs- und Generierungsprozessen von Informationen.

2.3 Ein bestimmter Erfolg wird nicht geschuldet.

3. Keine Beratung, kein Werkvertrag

3.1 Die Nutzung der Anwendung begründet keinen Beratungs-, Dienst- oder Werkvertrag.

3.2 Es wird keine rechtliche, steuerliche, medizinische, wirtschaftliche oder sonstige fachliche Beratung erbracht.

3.3 Entscheidungen liegen ausschließlich im Verantwortungsbereich des Nutzers.

4. KI-gestützte Funktionen

4.1 Die Anwendung nutzt automatisierte Systeme und künstliche Intelligenz.

4.2 Ergebnisse können fehlerhaft, unvollständig oder unzutreffend sein.

4.3 Der Nutzer ist verpflichtet, Ergebnisse eigenständig zu prüfen.

5. Verfügbarkeit

5.1 Kein Anspruch auf bestimmte Verfügbarkeit.

5.2 Änderungen oder Einstellung jederzeit möglich.

6. Pflichten des Nutzers

6.1 Keine rechtswidrigen Inhalte.

6.2 Verantwortung für Inhalte liegt beim Nutzer.

7. Nutzerdaten

7.1 Nutzungsrecht zur Verarbeitung für den Betrieb.

8. Datenverlust

8.1 Keine Haftung für Datenverlust.

8.2 Nutzer ist für Backups verantwortlich.

9. Vergütung

9.1 Nutzung kann kostenlos oder kostenpflichtig sein.

9.2 Änderungen jederzeit möglich.

10. Haftung

10.1 Haftung nur bei Vorsatz und grober Fahrlässigkeit.

10.2 Keine Haftung bei einfacher Fahrlässigkeit.

11. Vertragsbeendigung

11.1 Einstellung jederzeit möglich.

12. Schlussbestimmungen

12.1 Deutsches Recht.

12.2 Gerichtsstand ist der Sitz des Anbieters.

13. Anbieter

Name/Firma: [einzutragen]
Adresse: [einzutragen]
E-Mail: [einzutragen]
